import React from 'react';
import AppPage from './AppPage';
import content from './content/android.json';

const AndroidAppPage = () => <AppPage content={content} />;

export default AndroidAppPage;
